import React, { useCallback, useState } from 'react';
import Lozenge from '@atlaskit/lozenge';
import { ConditionalTooltip } from '@atlassian/jira-jql-builder-common/src/ui/conditional-tooltip/index.tsx';
import { ScreenReaderText } from '@atlassian/jira-accessibility/src/common/ui/screenreader-text/index.tsx';
import type { LozengeOption } from '../../../common/types.tsx';
import {
	PICKER_DROPDOWN_WIDTH,
	StyledLabel,
	StyledLozenge,
	StyledLozengeLabel,
	StyledOption,
} from '../../../common/ui/styled.tsx';

// Checkbox icon width = 24
// Margins and paddings around checkbox icon = 16
// Option right padding = (3 / 2) * 8
const DEFAULT_MAX_WIDTH = PICKER_DROPDOWN_WIDTH - 24 - 16 - (3 / 2) * 8;

type Props = {
	data: LozengeOption;
};

export const LozengeOptionLabel = ({ data }: Props): React.JSX.Element => {
	const [labelOverflows, setLabelOverflows] = useState(false);

	const onLabelRef = useCallback((node: HTMLElement | null) => {
		if (node != null) {
			setLabelOverflows(node.offsetWidth < node.scrollWidth);
		}
	}, []);

	return (
		<StyledOption>
			<StyledLabel>
				<StyledLozenge data-testid="jql-builder-basic-picker.ui.format-option-label.lozenge-option-label.lozenge">
					<Lozenge
						appearance={data.appearance}
						isBold={data.isBold}
						maxWidth={data.maxWidth ?? DEFAULT_MAX_WIDTH}
					>
						<ConditionalTooltip
							condition={labelOverflows}
							content={data.label}
							position="right"
							tag="span"
						>
							<StyledLozengeLabel ref={onLabelRef}>{data.label}</StyledLozengeLabel>
						</ConditionalTooltip>
					</Lozenge>
				</StyledLozenge>
			</StyledLabel>
			{data.disabledMessage && <ScreenReaderText>{data.disabledMessage}</ScreenReaderText>}
		</StyledOption>
	);
};
export default LozengeOptionLabel;
